const dsarDomain = "https://cache.zinus.secuvy.com",
  // const dsarDomain = "http://localhost:3000",
  key = "205eeb6f-69ff-41ee-ab45-674ad2d5cc55",
  consentUrl =
    "https://consent.zinus.secuvy.com/assets/3793199e-e402-447d-b2ba-f88458d8fe78/v29/policy.js",
  menuOptions = ["cookies", "subject-request", "company", "legalcenter"],
  dsarPath = "/privacy/rtype",
  dsarParams = { key: "205eeb6f-69ff-41ee-ab45-674ad2d5cc55" };
let isAlreadyRender = !1;
let isConsentUpdated = false;
let routeLocation = null,
  routeSubmenu = null;
window.addEventListener("message", e => {
  try {
    if (dsarDomain.includes(e.origin)) {
      var t = e.data;
      switch (t.type) {
        case "iframe-loaded":
          return void setTimeout(() => {
            var e = document.getElementById("secuvy-dsar-frame");
            e.contentWindow.postMessage({ type: "menu-options", data: menuOptions }, "*"),
              e.contentWindow.postMessage(
                { type: "consentId", consentUrl: consentUrl.split("/")[4] },
                "*",
              ),
              e.contentWindow.postMessage({ type: "consentUrl", url: consentUrl }, "*"),
              setKlaroConfig(!0);
            // if onCloseCookieWeight function is updated before the iframe is loaded, route to the location and submenu
            if (isConsentUpdated) {
              var s = document.getElementById("secuvy-dsar-frame");
              s.contentWindow.postMessage(
                {
                  type: "route",
                  location: routeLocation,
                  submenu: routeSubmenu,
                  cookiesDetails: KlaroConfig.getManager().savedConsents,
                },
                "*",
              );
            }
          }, 1e3);
        case "secuvy_consent_accept_selected":
          return void toggleChange(t.cookies);
        case "api_success":
          return void (document.getElementById("secuvy-iframe-header").style.display = "none");
        case "client_drawer_close":
          closeSecuvyDsarDrawer();
      }
    }
  } catch (s) {
    alert(s);
  }
});
const toRenderWeight = () => {
    try {
      var e = consentUrl.split("/").splice(0, 3).join("/") + "/common",
        t = `<div class=secuvy-mobile-widget-card id=secuvy-mobile-widget-card><div class=secuvy-mobile-widget-card-wrapper><div class=secuvy-mobile-widget-close-btn-wrapper><img alt=secuvy-mobile-widget-close-btn src=${e}/secuvy-mobile-widget-close-btn.svg id=secuvy-mobile-widget-button-closed height=16px onclick=hideSecuvyMobileWidget() width=16px></div><div class=secuvy-widget-card-desc id=secuvy-mobile-popup-description></div><div class=secuvy-mobile-widget-btn-wrapper><button class="secuvy-widget-btn secuvy-widget-btn-outlined"id=secuvy-mobile-weight-reject-all-btn onclick=resetContentClick()>Reject All</button><button class="secuvy-widget-btn secuvy-widget-btn-filled"id=secuvy-mobile-weight-accept-all-btn onclick='saveContentClick("accept_all")'>That's ok</button></div><div class=secuvy-mobile-widget-link-group><a href="#" class=secuvy-widget-link id=secuvy-mobile-widget-link-policies onclick='openSecuvyDsarDrawer("secuvy-appear-drawer","policies")'>View Policies</a><span class=secuvy-widget-link-divider></span><a href="#" class=secuvy-widget-link id=secuvy-mobile-widget-link-manage onclick='openSecuvyDsarDrawer("secuvy-appear-drawer","cookies")'>Manage Preferences</a></div><div class=secuvy-widget-link-dsr><a href="#" class=secuvy-widget-link id=secuvy-mobile-widget-link-dsr onclick='openSecuvyDsarDrawer("secuvy-appear-drawer","subject-request")'>Do not Sell My Personal Information</a></div></div><span class="secuvy-gpc-section-centent secuvy-mobile-gpc-section-centent"id=secuvy-mobile-gpc-section-centent><span class=secuvy-gpc-section-box id=secuvy-mobile-gpc-section-box>â– </span><p class=secuvy-gpc-section-desc id=secuvy-mobile-gpc-section-desc>GPC Signal detected</span></div><div class=secuvy-appear-drawer id=secuvy-side-drawer-modal-id><div class=secuvy-iframe-header id=secuvy-iframe-header><span class=secuvy-iframe-header-close onclick=closeSecuvyDsarDrawer()><img alt=secuvy-iframe-drawer-close-btn src=${e}/secuvy-iframe-drawer-close-btn.svg></span></div><div class=secuvy-iframe-footer><div class=secuvy-iframe-footer-wrapper><span class=footer-text>Powered by</span> <img alt=secuvy-logo src=${e}/secuvy-logo.svg height=16px width=80px></div></div></div><div class=secuvy-widget-button id=secuvy-widget-button onclick=showSecuvyWidget(!1)><img alt=secuvy-widget-button-logo src=${e}/secuvy-widget-button-logo.svg id=secuvy-widget-button-logo class=secuvy-widget-button-images style=display:none> <img alt=secuvy-widget-button-closed src=${e}/secuvy-widget-button-closed.svg id=secuvy-widget-button-closed class=secuvy-widget-button-images style=display:block></div><div class=secuvy-widget-card id=secuvy-widget-card><div class=secuvy-widget-card-body><div class=secuvy-widget-card-desc id=secuvy-popup-description></div><div class=secuvy-widget-btn-group><button class="secuvy-widget-btn secuvy-widget-btn-outlined"id=secuvy-weight-reject-all-btn onclick=resetContentClick()>Reject All</button> <button class="secuvy-widget-btn secuvy-widget-btn-filled"id=secuvy-weight-accept-all-btn onclick='saveContentClick("accept_all")'>That's Ok</button></div><div class=secuvy-widget-link-group><a href="#" class=secuvy-widget-link id=secuvy-widget-link-policies onclick='openSecuvyDsarDrawer("secuvy-appear-drawer","policies")'>View Policies</a> <span class=secuvy-widget-link-divider></span> <a href="#" class=secuvy-widget-link id=secuvy-widget-link-manage onclick='openSecuvyDsarDrawer("secuvy-appear-drawer","cookies")'>Manage Preferences</a></div><a href="#" class=secuvy-widget-link id=secuvy-widget-link-dsr onclick='openSecuvyDsarDrawer("secuvy-appear-drawer","subject-request")'>Do not Sell My Personal Information</a></div><span class=secuvy-gpc-section-centent id=secuvy-gpc-section-centent><span class=secuvy-gpc-section-box id=secuvy-gpc-section-box>â– </span><p class=secuvy-gpc-section-desc id=secuvy-gpc-section-desc>GPC Signal detected</span></div>`,
        s = (document.write(t), document.createElement("script"));
      (s.src = consentUrl),
        (s.id = "policyScript"),
        (s.async = !0),
        (s.onerror = () => {
          alert("Error occurred while loading script");
        }),
        document.head.appendChild(s);
    } catch (i) {
      alert("Exception in widget loading: " + i.toString());
    }
  },
  showSecuvyWidget = e => {
    try {
      var t = document.getElementById("secuvy-widget-button"),
        s = document.getElementById("secuvy-widget-button-logo"),
        i = document.getElementById("secuvy-widget-button-closed"),
        c = document.getElementById("secuvy-widget-card");
      e
        ? ((i.style.display = "block"),
          (s.style.display = "none"),
          t.setAttribute("onclick", "showSecuvyWidget(false);"),
          isAlreadyRender ? (c.style.display = "flex") : (c.style.display = "none"))
        : ((i.style.display = "none"),
          (s.style.display = "block"),
          (c.style.display = "none"),
          t.setAttribute("onclick", "showSecuvyWidget(true);"));
    } catch (n) {
      alert("Exception in widget drawer: " + n.toString());
    }
  },
  hideSecuvyMobileWidget = (e = !1) => {
    document.getElementById("secuvy-mobile-widget-card").style.display = e ? "block" : "none";
  },
  openSecuvyDsarDrawer = (e, t, s) => {
    routeLocation = t;
    routeSubmenu = s;
    if ((hideSecuvyMobileWidget(!1), isAlreadyRender)) toRouteIframeChild(t, s);
    else {
      e &&
        ((dsarParams.mode = e),
        t
          ? "policies" === (dsarParams.menu = t) && (dsarParams.policy = s)
          : (dsarParams.menu = null));
      try {
        var i,
          c = null;
        document.getElementById("secuvy-side-drawer-modal-id") &&
          !document.getElementById("secuvy-dsar-frame") &&
          ((i = document.getElementById("secuvy-side-drawer-modal-id")),
          ((c = document.createElement("iframe")).id = "secuvy-dsar-frame"),
          c.setAttribute("loading", "lazy"),
          c.setAttribute("frameborder", "0"),
          c.setAttribute("name", "Secuvy DSAR Frame"),
          c.setAttribute("title", "Secuvy Privacy Request"),
          (c.style.width = "100%"),
          (c.style.minHeight = "calc(100% - 52px)"),
          (c.style.height = "auto"),
          (c.style.overflow = "hidden"),
          i.appendChild(c),
          c.setAttribute(
            "src",
            dsarDomain + "/privacy/rtype?" + new URLSearchParams(dsarParams).toString(),
          )),
          showSecuvyWidget(!0);
      } catch (n) {
        alert(n);
      }
    }
  },
  closeSecuvyDsarDrawer =
    (toRenderWeight(),
    openSecuvyDsarDrawer("secuvy-appear-drawer"),
    () => {
      (document.getElementById("secuvy-widget-button").style.display = "none"),
        showSecuvyWidget(),
        document.getElementById("secuvy-side-drawer-modal-id").classList.remove("show");
    }),
  toRouteIframeChild =
    (window.addEventListener("keydown", e => {
      "Escape" === e.key && closeSecuvyDsarDrawer();
    }),
    (e, t = null) => {
      if (KlaroConfig) {
        try {
          var s = document.getElementById("secuvy-dsar-frame");
          document.getElementById("secuvy-side-drawer-modal-id").classList.add("show"),
            s.contentWindow.postMessage(
              {
                type: "route",
                location: e,
                submenu: t,
                cookiesDetails: KlaroConfig.getManager().savedConsents,
              },
              "*",
            );
        } catch (i) {
          alert(i);
        }
      }
    });
let Klaro, KlaroConfig;
function cookieDeleteManual(e, t) {
  try {
    let s = 0,
      i = setInterval(() => {
        if (!((s += 1) <= t)) return clearInterval(i);
        e.forEach(e => {
          e.externalScript ||
            window.klaro.getManager().savedConsents[e.name] ||
            (document.cookie = `${e.name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${e.cookies[0][2]};path=/`);
        });
      }, 1e3);
  } catch (c) {
    alert(c);
  }
}
document.addEventListener("scrollend", function () {
  try {
    "object" == typeof window.klaro && cookieDeleteManual(window.klaroConfig.services, 2);
  } catch (e) {
    alert(e);
  }
});
const setKlaroConfig = async (e = !1) => {
    var t = await document.getElementById("secuvy-dsar-frame");
    t &&
      e &&
      (await t.contentWindow.postMessage(
        {
          type: "klaroConfig",
          details: {
            ...Klaro,
          },
          cookieSelected: getCookieValue("secuvy"),
        },
        "*",
      ),
      (isAlreadyRender = !0));
  },
  onCloseCookieWeight =
    (window.addEventListener("load", function () {
      let e = setInterval(() => {
        try {
          if ("object" == typeof window.klaro) {
            var t = document.getElementById("secuvy");
            t.parentNode.removeChild(t);
            let { callback: s, ...i } = window.klaroConfig;
            (Klaro = i), (KlaroConfig = window.klaro), cookieDeleteManual(i.services, 10);
            var c = document.getElementById("secuvy-widget-card"),
              n = document.getElementById("secuvy-widget-button"),
              o = document.getElementsByClassName("secuvy_customer_external_link");
            if (o) for (let l = 0; l < o.length; l++) o[l].style.display = "block";
            getCookieValue("secuvy")
              ? ((c.style.display = "none"), (n.style.display = "none"), hideSecuvyMobileWidget())
              : ((c.style.display = "flex"),
                (n.style.display = "flex"),
                hideSecuvyMobileWidget(!0));
            var {
              decline: a,
              ok: d,
              okButtonColorModal: r = "#0085ca",
              popupDescription:
                y = "This site uses cookies. Some of them are essential, while others help us improve your experience.",
              thatsOkTextColor: u = "#FFFFFF",
              thatsOkTextSize: g = "0.8rem",
              declineAllTextColor: v = "#000000",
              declineAllTextSize: p = "0.8rem",
              dsrWidgetText: m = "Do not Sell My Personal Information",
              policiesWidgetText: w = "View Policies",
              managePerferanceWidgetText: b = "Manage Preferences",
            } = i.translations.en;
            return (
              (document.getElementById("secuvy-weight-reject-all-btn").innerHTML = a),
              (document.getElementById("secuvy-weight-accept-all-btn").innerHTML = d),
              (document.getElementById("secuvy-widget-link-policies").innerHTML = w),
              (document.getElementById("secuvy-widget-link-manage").innerHTML = b),
              (document.getElementById("secuvy-widget-link-dsr").innerHTML = m),
              (document.getElementById("secuvy-weight-reject-all-btn").style.color = v),
              (document.getElementById("secuvy-weight-accept-all-btn").style.color = u),
              (document.getElementById("secuvy-weight-reject-all-btn").style.fontSize = p),
              (document.getElementById("secuvy-weight-accept-all-btn").style.fontSize = g),
              (document.getElementById("secuvy-weight-accept-all-btn").style.backgroundColor = r),
              (document.getElementById("secuvy-weight-accept-all-btn").style.borderColor = r),
              (document.getElementById("secuvy-popup-description").innerHTML = y),
              (document.getElementById("secuvy-mobile-popup-description").innerHTML = y),
              (document.getElementById("secuvy-mobile-weight-reject-all-btn").innerHTML = a),
              (document.getElementById("secuvy-mobile-weight-reject-all-btn").style.color = v),
              (document.getElementById("secuvy-mobile-weight-reject-all-btn").style.fontSize = p),
              (document.getElementById("secuvy-mobile-weight-accept-all-btn").innerHTML = d),
              (document.getElementById("secuvy-mobile-weight-accept-all-btn").style.color = u),
              (document.getElementById("secuvy-mobile-weight-accept-all-btn").style.fontSize = g),
              (document.getElementById(
                "secuvy-mobile-weight-accept-all-btn",
              ).style.backgroundColor = r),
              (document.getElementById("secuvy-mobile-weight-accept-all-btn").style.borderColor =
                r),
              (document.getElementById("secuvy-mobile-widget-link-policies").innerHTML = w),
              (document.getElementById("secuvy-mobile-widget-link-manage").innerHTML = b),
              (document.getElementById("secuvy-mobile-widget-link-dsr").innerHTML = m),
              Klaro.isGpcEnabled &&
                ((this.document.getElementById("secuvy-gpc-section-centent").style.display =
                  "flex"),
                (this.document.getElementById("secuvy-gpc-section-box").style.color =
                  navigator.globalPrivacyControl ? "#33bb7b" : "#f05a55"),
                (this.document.getElementById("secuvy-gpc-section-desc").innerHTML =
                  "GPC signal " + (navigator.globalPrivacyControl ? "detected" : "not detected")),
                (this.document.getElementById("secuvy-mobile-gpc-section-centent").style.display =
                  "flex"),
                (this.document.getElementById("secuvy-mobile-gpc-section-box").style.color =
                  navigator.globalPrivacyControl ? "#33bb7b" : "#f05a55"),
                (this.document.getElementById("secuvy-mobile-gpc-section-desc").innerHTML =
                  "GPC signal " + (navigator.globalPrivacyControl ? "detected" : "not detected"))),
              setKlaroConfig(!0),
              (isConsentUpdated = true),
              clearInterval(e)
            );
          }
        } catch (h) {
          alert(h);
        }
      }, 100);
    }),
    () => {
      document
        .getElementById("secuvy-widget-button")
        .setAttribute("onclick", "showSecuvyWidget(true);"),
        (document.getElementById("secuvy-widget-button-logo").style.display = "block"),
        (document.getElementById("secuvy-widget-button-closed").style.display = "none"),
        (document.getElementById("secuvy-widget-card").style.display = "none"),
        (document.getElementById("secuvy-widget-button").style.display = "none"),
        hideSecuvyMobileWidget();
    }),
  createVisitorCookie = () => {
    var e = new Date(),
      t = Math.floor(1e16 * Math.random()).toString();
    return (
      getCookieValue("secuvy-consent") ||
      ((document.cookie =
        "secuvy-consent=" +
        t +
        ";expires=" +
        new Date(e.setDate(e.getDate() + klaroConfig.cookieExpiresAfterDays))),
      t)
    );
  };
async function saveContentClick(e) {
  let t = KlaroConfig.getManager();
  "accept_all" === e && (await t.changeAll(!0), Klaro.consentReload) && window.location.reload(),
    setTimeout(async () => {
      await t.saveAndApplyConsents(),
        setTimeout(() => {
          var e;
          let s = {
              user: "guest",
              version: "1.0.0",
              uniqueVisitorId: createVisitorCookie(),
              countryCode: secuvy_config_country,
              services: [],
              policyName: secuvy_config_policyDetails.policyName,
              policyId: secuvy_config_policyDetails.policyId,
              domain: window.location.hostname || window.location.host,
              consentId: secuvy_config_consentId,
              cookiePageUrl: window.location.href,
            },
            i =
              (secuvy_config_policyDetails &&
                (e = document.cookie
                  .split(";")
                  .find(e => e.includes(secuvy_config_policyDetails + "="))) &&
                (s.uniqueVisitorId = e.split("=")[1] || ""),
              window.klaro.defaultConfig.services.forEach(
                ({ cookies: e, name: i, purposes: c, title: n }) => {
                  s.services.push({
                    cookies: e,
                    name: i,
                    purposes: c,
                    title: n,
                    consent: (t.savedConsents && t.savedConsents[i]) || !1,
                  });
                },
              ),
              new XMLHttpRequest()),
            c = !1;
          s.services.every(e => !0 === e.consent) && (c = !0),
            i.open("POST", secuvy_config_api_url),
            i.setRequestHeader("Content-Type", "application/json;charset=UTF-8"),
            i.send(JSON.stringify({ ...s, isCookieOptedIn: c }));
        }, 100);
    }, 1e3),
    onCloseCookieWeight();
}
async function toggleChange(e) {
  for (let t = 0; t < e.length; t++)
    await KlaroConfig.getManager().updateConsent(e[t].key, e[t].value);
  saveContentClick();
}
async function resetContentClick() {
  await KlaroConfig.getManager().changeAll(!1), onCloseCookieWeight(), saveContentClick();
}
function getCookieValue(e) {
  var t = RegExp("(?:^|; )" + e + "=([^;]*)"),
    t = document.cookie.match(t);
  return !("secuvy" !== e || !t) || (t ? decodeURIComponent(t[1]) : null);
}
